"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _MoreLessContent = _interopRequireDefault(require("./MoreLessContent"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    boldFont: {
      fontWeight: 'bold'
    },
    countryWrapper: {
      paddingBottom: '32px'
    },
    buSpacing: {
      marginBottom: '16px',
      fontSize: '14px'
    },
    province: {
      marginBottom: '16px',
      fontWeight: 'bold',
      fontSize: '18px'
    }
  };
});
var RegionalOfficeListing = function RegionalOfficeListing(props) {
  var id = props.id,
    name = props.name,
    country = props.country,
    province = props.province,
    city = props.city,
    businessUnits = props.businessUnits,
    address1 = props.address1,
    address2 = props.address2,
    postalZip = props.postalZip,
    emailIds = props.emailIds,
    phoneNumbers = props.phoneNumbers,
    faxNumber = props.faxNumber,
    googlemapstring = props.googlemapstring;
  var classes = useStyles();
  var spacer = __jsx(_core.Grid, {
    item: true,
    sm: 1,
    implementation: "css",
    xsDown: true,
    component: _core.Hidden
  });
  return __jsx(_core.Grid, {
    container: true,
    className: classes.countryWrapper,
    id: id
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12
  }, province && __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: province
    },
    className: classes.province
  }), name && __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: name
    },
    style: {
      fontSize: '14px'
    },
    className: classes.boldFont
  })), __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    style: {
      fontSize: '14px'
    }
  }, address1 && __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: address1
    }
  }), address2 && __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: address2
    }
  }), __jsx("div", null, city ? __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(city, " ")
    }
  }) : null, postalZip && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(postalZip, " ")
    }
  })), country && __jsx("div", null, country)), spacer, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 5,
    style: {
      fontSize: '14px'
    }
  }, __jsx("div", null, phoneNumbers && phoneNumbers.map(function (phoneNumbersText, index) {
    return __jsx("div", {
      key: index,
      dangerouslySetInnerHTML: {
        __html: phoneNumbersText
      }
    });
  })), emailIds && emailIds.map(function (emailIdsText, index) {
    return __jsx("div", null, __jsx(_core.Link, {
      key: index,
      className: classes.boldFont,
      href: "mailto:".concat(emailIdsText),
      dangerouslySetInnerHTML: {
        __html: emailIdsText
      }
    }));
  }), __jsx("div", null, faxNumber && faxNumber.map(function (faxNumberText, index) {
    return __jsx("div", {
      dangerouslySetInnerHTML: {
        __html: faxNumberText
      }
    });
  })), googlemapstring && __jsx(_core.Link, {
    target: "_blank",
    className: classes.boldFont,
    rel: "noopener",
    href: googlemapstring
  }, "View Map")), businessUnits && businessUnits.length > 0 && __jsx(_MoreLessContent.default, {
    moreText: "More",
    lessText: "Less"
  }, businessUnits.map(function (units, index) {
    return __jsx(_react.default.Fragment, null, __jsx(_core.Grid, {
      container: true,
      className: classes.buSpacing
    }, __jsx(_core.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, units.name), spacer, __jsx(_core.Grid, {
      item: true,
      xs: 12,
      sm: 5
    }, units.phone, __jsx("br", null), __jsx(_core.Link, {
      href: "".concat("mailto:" + units.email)
    }, units.email))));
  })));
};
var _default = RegionalOfficeListing;
exports.default = _default;